var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolDocWorkflow01 = function SvgSolDocWorkflow01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_doc_workflow-01_svg2__a",
    x1: 31.39,
    x2: 186.11,
    y1: 178.93,
    y2: 44.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_doc_workflow-01_svg2__a",
    id: "sol_doc_workflow-01_svg2__b",
    x1: -2.76,
    x2: 151.97,
    y1: 139.62,
    y2: 5.22
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_doc_workflow-01_svg2__a",
    id: "sol_doc_workflow-01_svg2__c",
    x1: -13.28,
    x2: 141.45,
    y1: 127.51,
    y2: -6.89
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_doc_workflow-01_svg2__a",
    id: "sol_doc_workflow-01_svg2__d",
    x1: 80.11,
    x2: 234.84,
    y1: 235.02,
    y2: 100.62
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_doc_workflow-01_svg2__a",
    id: "sol_doc_workflow-01_svg2__e",
    x1: 36.95,
    x2: 191.68,
    y1: 185.33,
    y2: 50.93
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_doc_workflow-01_svg2__a",
    id: "sol_doc_workflow-01_svg2__f",
    x1: 24.45,
    x2: 179.18,
    y1: 170.94,
    y2: 36.54
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_doc_workflow-01_svg2__a",
    id: "sol_doc_workflow-01_svg2__g",
    x1: 31.47,
    x2: 186.2,
    y1: 179.03,
    y2: 44.63
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_doc_workflow-01_svg2__a",
    id: "sol_doc_workflow-01_svg2__h",
    x1: 38.51,
    x2: 193.24,
    y1: 187.11,
    y2: 52.71
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_doc_workflow-01_svg2__a",
    id: "sol_doc_workflow-01_svg2__i",
    x1: 55.78,
    x2: 210.51,
    y1: 207.01,
    y2: 72.61
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_doc_workflow-01_svg2__a",
    id: "sol_doc_workflow-01_svg2__j",
    x1: 62.8,
    x2: 217.53,
    y1: 215.1,
    y2: 80.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_doc_workflow-01_svg2__a",
    id: "sol_doc_workflow-01_svg2__k",
    x1: 69.83,
    x2: 224.56,
    y1: 223.18,
    y2: 88.78
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M159.34 118.14H139.4v-14.11a3.91 3.91 0 0 0-3.91-3.91H103.9v-12.5h4.28c1.98 0 3.65-1.48 3.88-3.45l.71-6.01c.06-.52.36-.98.8-1.24.15-.09.3-.18.44-.26.43-.26.98-.29 1.46-.09l5.75 2.36c1.81.74 3.89.03 4.86-1.66l9.09-15.78c.99-1.72.53-3.91-1.07-5.09l-5.07-3.74c-.43-.32-.68-.84-.68-1.41v-.23c0-.56.24-1.07.68-1.39l5.07-3.74a3.905 3.905 0 0 0 1.07-5.09l-9.09-15.77a3.896 3.896 0 0 0-4.87-1.66l-5.88 2.42c-.48.2-1.03.16-1.47-.09l-.29-.17c-.44-.25-.74-.72-.8-1.24l-.71-6.15a3.913 3.913 0 0 0-3.88-3.46H90c-1.98 0-3.65 1.49-3.88 3.46l-.7 6.03c-.07.59-.42 1.13-.94 1.43-.03.01-.05.03-.07.04-.51.29-1.13.33-1.68.11l-5.77-2.37a3.92 3.92 0 0 0-4.87 1.66L63 40.81a3.905 3.905 0 0 0 1.07 5.09l5.08 3.74c.43.32.69.84.68 1.42v.2c0 .58-.25 1.09-.68 1.41l-5.08 3.74A3.905 3.905 0 0 0 63 61.5l9.09 15.78c.98 1.69 3.06 2.4 4.87 1.66l5.75-2.36c.49-.2 1.03-.16 1.45.08.15.09.3.18.47.27.43.25.72.71.79 1.23l.71 6.01c.23 1.97 1.9 3.45 3.88 3.45h6.09v12.5H63.09a3.91 3.91 0 0 0-3.91 3.91v14.11H39.24a3.91 3.91 0 0 0-3.91 3.91v59.38a3.91 3.91 0 0 0 3.91 3.91h47.7a3.91 3.91 0 0 0 3.91-3.91v-25.78h16.9v25.78a3.91 3.91 0 0 0 3.91 3.91h47.7a3.91 3.91 0 0 0 3.91-3.91v-59.38a3.91 3.91 0 0 0-3.91-3.91ZM93.48 79.82l-.3-2.56c-.35-2.97-2.09-5.62-4.64-7.08-.11-.06-.22-.13-.34-.2-2.53-1.52-5.68-1.75-8.44-.62l-2.59 1.06-5.64-9.79 2.27-1.67c2.42-1.79 3.86-4.67 3.86-7.7v-.17a9.55 9.55 0 0 0-3.86-7.74l-2.26-1.67 5.64-9.79 2.6 1.07a9.77 9.77 0 0 0 8.62-.6c.02-.01.04-.03.07-.04h.01a9.76 9.76 0 0 0 4.73-7.26l.3-2.57h11.22l.31 2.69a9.49 9.49 0 0 0 4.66 7.11l.22.13c2.53 1.5 5.68 1.72 8.42.6l2.71-1.12 5.64 9.79-2.26 1.67a9.51 9.51 0 0 0-3.86 7.71v.19c0 3.04 1.44 5.92 3.86 7.71l2.27 1.67-5.64 9.79-2.59-1.06c-2.75-1.13-5.91-.9-8.45.63-.11.07-.22.13-.32.19-2.57 1.47-4.3 4.12-4.65 7.09l-.3 2.56H93.52Zm-10.46 97.7H43.14v-51.56h39.88zm24.72-55.47v25.78h-16.9v-25.78a3.91 3.91 0 0 0-3.91-3.91H66.99v-10.2h64.6v10.2h-19.94a3.91 3.91 0 0 0-3.91 3.91m47.7 55.47h-39.88v-51.56h39.88z",
    style: {
      fill: "url(#sol_doc_workflow-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.76 51.15c0-7.54-6.13-13.67-13.67-13.67s-13.67 6.13-13.67 13.67 6.13 13.67 13.67 13.67 13.67-6.13 13.67-13.67m-13.67 5.86c-3.23 0-5.85-2.63-5.85-5.85s2.63-5.85 5.85-5.85 5.86 2.63 5.86 5.85-2.63 5.85-5.86 5.85",
    style: {
      fill: "url(#sol_doc_workflow-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.83 148.61H11.6c-2.09 0-3.79-1.7-3.79-3.79V58.84c0-2.09 1.7-3.79 3.79-3.79h30.55l-2.48 2.62a3.91 3.91 0 0 0 .15 5.52c.76.72 1.72 1.07 2.68 1.07 1.04 0 2.07-.41 2.84-1.22l8.71-9.21c1.44-1.52 1.39-3.98-.08-5.45l-8.72-8.68c-1.53-1.52-4-1.52-5.52.01s-1.52 4 .01 5.53l2.01 2.01H11.6c-6.39 0-11.6 5.2-11.6 11.6v85.98c0 6.39 5.2 11.6 11.6 11.6h12.23a3.91 3.91 0 1 0 0-7.82",
    style: {
      fill: "url(#sol_doc_workflow-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.09 114.68a3.91 3.91 0 0 0-3.91 3.91v26.24c0 2.09-1.7 3.79-3.79 3.79h-4.87l2.47-2.62c1.48-1.57 1.42-4.04-.15-5.52s-4.04-1.42-5.52.15l-8.71 9.21c-1.44 1.52-1.4 3.98.08 5.45l8.71 8.68c.76.76 1.76 1.14 2.76 1.14s2-.38 2.77-1.15c1.52-1.53 1.52-4 0-5.52l-2.02-2.01h4.49c6.39 0 11.6-5.2 11.6-11.6v-26.24a3.91 3.91 0 0 0-3.91-3.91",
    style: {
      fill: "url(#sol_doc_workflow-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.4 47.24h-38.79a3.91 3.91 0 1 0 0 7.82h38.79c2.09 0 3.79 1.7 3.79 3.79v24.59a3.91 3.91 0 1 0 7.82 0V58.85c0-6.39-5.2-11.6-11.6-11.6Z",
    style: {
      fill: "url(#sol_doc_workflow-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8 141.45h18.17a3.91 3.91 0 1 0 0-7.82H53.8a3.91 3.91 0 1 0 0 7.82",
    style: {
      fill: "url(#sol_doc_workflow-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8 155.64h18.17a3.91 3.91 0 1 0 0-7.82H53.8a3.91 3.91 0 1 0 0 7.82",
    style: {
      fill: "url(#sol_doc_workflow-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8 169.83h18.17a3.91 3.91 0 1 0 0-7.82H53.8a3.91 3.91 0 1 0 0 7.82",
    style: {
      fill: "url(#sol_doc_workflow-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.66 141.45h18.17a3.91 3.91 0 1 0 0-7.82h-18.17a3.91 3.91 0 1 0 0 7.82",
    style: {
      fill: "url(#sol_doc_workflow-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.66 155.64h18.17a3.91 3.91 0 1 0 0-7.82h-18.17a3.91 3.91 0 1 0 0 7.82",
    style: {
      fill: "url(#sol_doc_workflow-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.66 169.83h18.17a3.91 3.91 0 1 0 0-7.82h-18.17a3.91 3.91 0 1 0 0 7.82",
    style: {
      fill: "url(#sol_doc_workflow-01_svg2__k)"
    }
  }));
};
export default SvgSolDocWorkflow01;